module.exports = __webpack_public_path__ + "img/mb_how_4.ba97a896.png";